import { mapGetters } from 'vuex';
import HtmlRenderContainer from '@/components/content-management/html-render-container';
import QuizOption from '@/components/content-management/quiz/render/option';

import QuizMixin from '@/mixins/quiz';

export default {
  props: {
    questions: {
      type    : Array,
      default : () => ([])
    },
    content: {
      type    : Object,
      default : () => ({})
    }
  },
  components: {
    QuizOption,
    HtmlRenderContainer
  },
  mixins: [QuizMixin],
  data() {
    return {
      currentIndex: 0
    };
  },
  computed: {
    ...mapGetters({
      isImpersonated: '_core/auth/isImpersonated'
    }),
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    isFirst() {
      return this.currentIndex === 0;
    },
    isLast() {
      return this.currentIndex === this.questions.length - 1;
    },
    question() {
      return this.questions[this.currentIndex];
    }
  },
  methods: {
    getLetter(index) {
      return String.fromCharCode(97 + index);
    },
    getProgressionValue(currentQuestionIndex) {
      return ((currentQuestionIndex + 1) / this.questions.length) * 100;
    },
    getOptionType(question, option) {
      if (this.isQuizFinished(this.content) || this.isQuizExpired(this.content) || this.isImpersonated) {
        return 'disabled';
      } else {
        return this.isOptionSelectedByStudent(question.questionId, option.optionId) ? 'selected' : 'default';
      }
    },
    answerObjectiveQuestion(option) {
      if (!this.isQuizFinished(this.content) && !this.isQuizExpired(this.content) && !this.isImpersonated) {
        this.$emit('answer-question', { questionId: this.question.questionId, optionId: option.optionId });
      }
    },
    sendFinalAnswers() {
      if (!this.isQuizFinished(this.content) && !this.isQuizExpired(this.content) && !this.isImpersonated) {
        const currentAttempt = this.findCurrentAttempt();

        if (currentAttempt) {
          if (!this.checkIfAllQuizQuestionsAreAnswered(currentAttempt, this.questions)) {
            this.$emit('not-answered-all');
          } else {
            this.$emit('send-answers', currentAttempt.attemptId);
            this.currentIndex = 0;
          }
        } else {
          this.$emit('not-answered-any');
        }
      }
    },
    scrollToQuestionHeader() {
      const element = document.getElementById(`question-wrapper_${this.content.topicId}`);
      const headerOffset = 200;

      window.scroll({
        top      : (element && element.getBoundingClientRect().top + window.pageYOffset) - headerOffset,
        behavior : 'smooth'
      });
    }
  }
};
